/**
 * BugEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { VisitEntity } from "../VisitEntity";
import { MapEntity } from "../MapEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { MapLocationEntity } from "../MapLocationEntity";
import { MapSceneEntity } from "../MapSceneEntity";
import { PhaseEntity } from "../PhaseEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { BugEntity } from "../BugEntity";
import { FormEntity } from "../FormEntity";
import { FormTypeVersionEntity } from "../FormTypeVersionEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { DocumentEntity } from "../DocumentEntity";
import { BugAnnotationEntity } from "../BugAnnotationEntity";
import { SignOffEntity } from "../SignOffEntity";
declare global {
    interface EntityTypeMap {
        Bug: BugEntity;
    }
}
export abstract class BugGeneratedEntity extends BaseEntity {
    public abstract bugId: string;
    public abstract templateId: string | null;
    public abstract index: number;
    public abstract index_planLegacy_local: number;
    public abstract index_planLegacy_global: number;
    public abstract creationDate: Date;
    public abstract openDate: Date;
    public abstract dueDate: Date | null;
    public abstract closeDate: Date | null;
    public abstract location: string | null;
    public abstract positionX: number | null;
    public abstract positionY: number | null;
    public abstract text: string | null;
    public abstract relatedFormFieldId: string | null;
    public abstract temp: boolean;
    public abstract lastModified: Date;
    public abstract noPosition: boolean | null;
    public abstract isTodayClosed: boolean;
    public abstract project: ProjectEntity;
    public abstract visit: VisitEntity | null;
    public abstract closeVisit: VisitEntity | null;
    public abstract map: MapEntity;
    public abstract workPackage: WorkPackageEntity | null;
    public abstract mapLocation: MapLocationEntity | null;
    public abstract mapScene: MapSceneEntity | null;
    public abstract phase: PhaseEntity;
    public abstract bugGroup: BugGroupEntity | null;
    public abstract relatedParentBug: BugEntity | null;
    public abstract relatedForm: FormEntity | null;
    public abstract relatedFormHistory: FormTypeVersionEntity | null;
    public abstract currentPhase: PhaseEntity;
    public abstract stateNoteCache: BugNoteEntity | null;
    public abstract readonly relatedChildBugs: ReadonlyArray<BugEntity>;
    public abstract readonly notes: ReadonlyArray<BugNoteEntity>;
    public abstract readonly relatedDocuments: ReadonlyArray<DocumentEntity>;
    public abstract readonly annotations: ReadonlyArray<BugAnnotationEntity>;
    public abstract signOff: SignOffEntity | null;
}
